module.exports = __webpack_public_path__ + "static/media/SWSCRC1-10.acb13996.mp3";